module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"headTitle":"","headDescription":""},"nl-BE":{"headTitle":"","headDescription":""},"es-ES":{"headTitle":"","headDescription":""},"de-DE":{"headTitle":"Impressum","headDescription":"Impressum"},"fr-BE":{"headTitle":"","headDescription":""},"fr-FR":{"headTitle":"","headDescription":""},"it-IT":{"headTitle":"","headDescription":""}}')
  delete Component.options._Ctor
}
